import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { UserKeys } from './user.keys';

export const syncUser = (legacyId: string | undefined): Promise<void> => {
  if (legacyId === null || undefined) {
    throw new Error('id is required');
  }

  return clients.admin.post(`/users/sync/${legacyId}`);
};

export function useSyncUser(
  legacyId: string | undefined,
  options?: UseMutationOptions<void, AxiosError, void>,
) {
  const queryClient = useQueryClient();

  return useMutation(() => syncUser(legacyId), {
    onSuccess: () => {
      queryClient.invalidateQueries(UserKeys.lists());
      queryClient.invalidateQueries(UserKeys.details());
    },
    onError: (error) => {
      console.error(error);
    },
    ...options,
  });
}
